<template>
  <b-modal id="view-counselor-modal" ref="modal" class="large-modal" size="xl">
    <template #modal-header>
      <div class="upper">
        <label>College Details</label>
        <div v-if="college" class="new-title">
          {{ college.name }}
        </div>
      </div>
      <button class="close" @click="hide()">×</button>
    </template>

    <div v-if="college && college.report" class="row">
      <div class="col-12" style="margin-top: 45px">
        <div class="row row-eq-height">
          <div class="col-12 col-md-6">
            <div class="dashboard-card light stat">
              <label>Student Registrations</label>
              <h2>{{ college.report.num_students_registered | number }}</h2>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="dashboard-card light stat">
              <label>Counselor Registrations</label>
              <h2>{{ college.report.num_counselors_registered | number }}</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="dashboard-card light mt-3">
              <h2 class="mb-4">College Stats</h2>
              <table class="table bm-table">
                <tbody>
                  <tr>
                    <td>Individual Sessions</td>
                    <td class="text-right">
                      {{
                        college.report.num_individual_sessions_scheduled
                          | number
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>Wellbeing Workshops</td>
                    <td class="text-right">
                      {{ college.report.num_group_sessions_scheduled | number }}
                    </td>
                  </tr>
                  <tr>
                    <td>On-Campus Events</td>
                    <td class="text-right">
                      {{ college.report.num_college_events_scheduled | number }}
                    </td>
                  </tr>
                  <tr v-if="college.report.initial_individual_session_credits">
                    <td>Individual Session Credits</td>
                    <td class="text-right">
                      {{
                        college.report.current_individual_session_credits
                          | number
                      }}
                      of
                      {{
                        college.report.initial_individual_session_credits
                          | number
                      }}
                      left
                    </td>
                  </tr>

                  <tr v-if="college.report.initial_group_session_credits">
                    <td>Wellbeing Workshop Credits</td>
                    <td class="text-right">
                      {{
                        college.report.current_group_session_credits | number
                      }}
                      of
                      {{
                        college.report.initial_group_session_credits | number
                      }}
                      left
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div v-if="appointmentData" class="row">
          <div class="col-12">
            <div class="dashboard-card light mt-3">
              <h2 class="mb-4">Sessions</h2>
              <div class="chart-holder">
                <column-chart
                  :library="chartOptions"
                  :data="appointmentData"
                  :colors="['#4cf2f0']"
                  :legend="false"
                  height="100%"
                  width="100%"
                />
              </div>
            </div>
          </div>
        </div>

        <div v-if="college.report.demographics" class="row">
          <div class="col-12">
            <div class="">
              <h2 class="mb-45 mt-30">
                Demographics ({{
                  college.report.demographics.total_students | number
                }}
                Total Students)
              </h2>

              <div class="row">
                <div class="col-12 col-lg-6">
                  <div class="dashboard-card light">
                    <div class="chart-container">
                      <h3>Gender</h3>
                      <div class="chart-holder">
                        <pie-chart
                          :library="pieChartOptions"
                          :donut="true"
                          :data="pieData1"
                          :colors="[
                            '#4cf2f0',
                            '#77e9b8',
                            '#9de093',
                            '#c0d476',
                            '#e0c567',
                            '#e49b4d',
                            '#e16e47',
                            '#dc564b',
                            '#d43d51'
                          ]"
                          height="100%"
                          width="100%"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="dashboard-card light">
                    <div class="chart-container">
                      <h3>Race</h3>
                      <div class="chart-holder">
                        <pie-chart
                          :library="pieChartOptions"
                          :donut="true"
                          :data="pieData2"
                          :colors="[
                            '#4cf2f0',
                            '#77e9b8',
                            '#9de093',
                            '#c0d476',
                            '#e0c567',
                            '#e49b4d',
                            '#e16e47',
                            '#dc564b',
                            '#d43d51'
                          ]"
                          height="100%"
                          width="100%"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="dashboard-card light">
                    <div class="chart-container">
                      <h3>Athlete</h3>
                      <div class="chart-holder">
                        <pie-chart
                          :library="pieChartOptions"
                          :donut="true"
                          :data="pieData3"
                          :colors="[
                            '#4cf2f0',
                            '#77e9b8',
                            '#9de093',
                            '#c0d476',
                            '#e0c567',
                            '#e49b4d',
                            '#e16e47',
                            '#dc564b',
                            '#d43d51'
                          ]"
                          height="100%"
                          width="100%"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="dashboard-card light">
                    <div class="chart-container">
                      <h3>International</h3>
                      <div class="chart-holder">
                        <pie-chart
                          :library="pieChartOptions"
                          :donut="true"
                          :data="pieData4"
                          :colors="[
                            '#4cf2f0',
                            '#77e9b8',
                            '#9de093',
                            '#c0d476',
                            '#e0c567',
                            '#e49b4d',
                            '#e16e47',
                            '#dc564b',
                            '#d43d51'
                          ]"
                          height="100%"
                          width="100%"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="dashboard-card light">
                    <div class="chart-container">
                      <h3>On-Campus</h3>
                      <div class="chart-holder">
                        <pie-chart
                          :library="pieChartOptions"
                          :donut="true"
                          :data="pieData5"
                          :colors="[
                            '#4cf2f0',
                            '#77e9b8',
                            '#9de093',
                            '#c0d476',
                            '#e0c567',
                            '#e49b4d',
                            '#e16e47',
                            '#dc564b',
                            '#d43d51'
                          ]"
                          height="100%"
                          width="100%"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="dashboard-card light">
                    <div class="chart-container">
                      <h3>Full Time</h3>
                      <div class="chart-holder">
                        <pie-chart
                          :library="pieChartOptions"
                          :donut="true"
                          :data="pieData6"
                          :colors="[
                            '#4cf2f0',
                            '#77e9b8',
                            '#9de093',
                            '#c0d476',
                            '#e0c567',
                            '#e49b4d',
                            '#e16e47',
                            '#dc564b',
                            '#d43d51'
                          ]"
                          height="100%"
                          width="100%"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="college.report.survey_results" class="row">
          <div class="col-12">
            <div>
              <h2 v-if="college.report.survey_results" class="mb-30 mt-30">
                Survey Stats ({{
                  college.report.survey_results.total_survey_responses
                }}
                total responses)
              </h2>
              <div class="row row-eq-height survey-list">
                <div
                  v-for="question in college.report.survey_results
                    .question_breakdowns"
                  :key="question.question_text"
                  class="col-12 col-md-6"
                >
                  <div class="dashboard-card light">
                    <h4>{{ question.question_text }}</h4>
                    <table class="table bm-table">
                      <tbody>
                        <template v-for="answer in question.answer_breakdowns">
                          <tr v-if="answer.number_of_responses > 0" :key="answer.answer_text">
                            <td>
                              {{ answer.answer_text }}
                            </td>
                            <td class="text-right">
                              {{ answer.number_of_responses | number }}
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template v-slot:modal-footer>
      <button class="btn" type="button" @click="hide()">Dismiss</button>
    </template>
  </b-modal>
</template>

<script>
import AdminClient from '@/api/AdminClient';
import Chart from 'chart.js';
import Vue from 'vue';
import Chartkick from 'vue-chartkick';

Vue.use(Chartkick.use(Chart));

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export default {
  name: 'ViewCollegeModal',

  props: {
    reloadColleges: {
      type: Function,
      required: true
    }
  },

  data() {
    return {
      adminClient: new AdminClient(this.$http),

      appointmentData: null,

      pieData1: null,
      pieData2: null,
      pieData3: null,
      pieData4: null,
      pieData5: null,
      pieData6: null,

      college: null,

      pieChartOptions: {
        elements: {
          point: {
            radius: 4
          },
          arc: {
            borderWidth: 0
          }
        },
        legend: {
          labels: {
            fontColor: '#fff'
          },
          position: 'bottom'
        }
      },
      chartOptions: {
        layout: {
          padding: {
            left: 10,
            right: 5,
            top: 5,
            bottom: 2
          }
        },
        scales: {
          xAxes: [
            {
              display: true,
              ticks: {
                fontSize: 10,
                fontColor: '#c8d2dc'
              }
            }
          ],
          yAxes: [
            {
              display: false,
              ticks: {
                fontSize: 14,
                fontColor: '#c8d2dc'
              }
            }
          ]
        },
        elements: {
          point: {
            radius: 4
          },
          arc: {
            borderWidth: 0
          }
        },
        defaultFontFamily:
          "'Playfair Display', Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        defaultFontSize: 30,
        borderWidth: 0
      }
    };
  },

  methods: {
    show(college) {
      this.college = college;
      this.appointmentData = null;
      this.pieData = null;

      if (
        this.college.report.appointment_report &&
        this.college.report.appointment_report.month_reports
      ) {
        const monthReports =
          this.college.report.appointment_report.month_reports || [];

        if (monthReports.length) {
          const data = {};

          monthReports.forEach((report) => {
            const monthName = monthNames[report.month - 1];
            data[monthName.toUpperCase().substr(0, 3)] =
              report.number_of_appointments || 0;
          });

          this.appointmentData = [
            {
              name: 'Appointments',
              data
            }
          ];
        }
      }

      if (this.college.report.demographics) {
        const total = this.college.report.demographics.total_students || 0;

        this.pieData1 = [
          ['Male', this.college.report.demographics.gender_male],
          ['Female', this.college.report.demographics.gender_female],
          ['Transgender-Male', this.college.report.demographics.gender_transgender_male],
          ['Transgender-Female', this.college.report.demographics.gender_transgender_female],
          ['Non-Binary', this.college.report.demographics.gender_non_binary],
          ['Exploring/Unknown', this.college.report.demographics.gender_unknown],
          ['Preferred not to answer', this.college.report.demographics.gender_prefer_not_to_say],
          ['Other', this.college.report.demographics.gender_other],
          ['N/A', this.college.report.demographics.gender_na]
        ];

        this.pieData2 = [
          ['White', this.college.report.demographics.race_white],
          ['Black', this.college.report.demographics.race_black],
          ['Native', this.college.report.demographics.race_native],
          ['Asian', this.college.report.demographics.race_asian],
          ['Pacific', this.college.report.demographics.race_pacific],
          ['Multiracial', this.college.report.demographics.race_multiracial],
          ['Hispanic', this.college.report.demographics.race_hispanic],
          ['Preferred not to answer', this.college.report.demographics.race_prefer_not_to_answer],
          ['Other', this.college.report.demographics.race_other]
        ];

        this.pieData3 = [
          ['Athlete', this.college.report.demographics.student_athlete],
          [
            'Not Athlete',
            total - this.college.report.demographics.student_athlete
          ]
        ];

        this.pieData4 = [
          [
            'International',
            this.college.report.demographics.international_student
          ],
          [
            'Not International',
            total - this.college.report.demographics.international_student
          ]
        ];

        this.pieData5 = [
          ['On', this.college.report.demographics.live_on_campus],
          ['Off', total - this.college.report.demographics.live_on_campus]
        ];

        this.pieData6 = [
          [
            'Full Time',
            this.college.report.demographics.student_status_full_time
          ],
          [
            'Part Time',
            this.college.report.demographics.student_status_part_time
          ]
        ];
      }

      this.$refs.modal.show();
    },

    hide() {
      this.$refs.modal.hide();
    }
  }
};
</script>

<style lang="scss" scoped>
#view-counselor-modal {
  .upper {
    display: block;
    position: relative;
    padding-right: 30px;
  }

  label {
    @include label;

    display: block;
    margin-bottom: 10px;
  }

  .date {
    font-size: 18px;
    color: rgba(white, 0.75);
  }

  .pills {
    margin-top: 20px;
  }

  .new-title {
    display: block;
    color: white;
    font-size: 40px;
    font-weight: 700;
    font-family: 'Playfair Display', serif;
    line-height: 1;
  }

  .description {
    opacity: 0.6;
  }

  h6 {
    font-weight: normal !important;
    font-size: 25px;
    margin-top: 30px;
    margin-bottom: 10px;

    span {
      font-weight: bold !important;
    }
  }

  .green {
    font-size: 13px;
    color: $green;
  }

  .bio {
    display: block;
    font-size: 18px;
    margin-top: 30px;
    margin-bottom: 30px;
  }

  .chart-holder {
    position: relative;
    left: -15px;
    width: calc(100% + 15px);
    height: 240px;
    padding: 30px;
  }

  .chart-holder-line {
    position: relative;
    left: -15px;
    width: calc(100% + 15px);
    min-height: 150px;
  }

  .stat {
    padding: 25px 30px;

    label {
      @include label;

      display: inline-block;
      color: $green;
      margin-bottom: -5px;
    }

    h2 {
      font-size: 60px;
      margin-top: -5px;
    }
  }

  .row-eq-height {
    .dashboard-card {
      height: calc(100% - 20px);
    }
  }

  .replacement-label {
    text-transform: uppercase;
    font-size: 10px;
    opacity: 0.75;
    letter-spacing: 0.1rem;
    margin-bottom: 5px;
    color: white;
  }

  .chart-container {
    h3 {
      border-bottom: solid 1px rgba(white, 0.1);
      display: block;
      padding-bottom: 12px;
    }
  }
}

.survey-list {
  list-style-type: none;
  padding-left: 0;

  h4 {
    margin-bottom: 30px;
    color: white;
    font-size: 20px;
  }

  table {
    margin-bottom: 45px;
  }
}
</style>
